/**
 * 岗位级别枚举
 */
export default Object.freeze([
    'P1',
    'P2',
    'P3',
    'P4',
    'P5',
    'P6',
    'P7',
    'P8',
])